<script setup lang="ts">
import { RouterView } from 'vue-router'
import { useSecurityStore } from './stores/gae/store_security'
import { onMounted, watch } from 'vue'
import { useAppData } from './stores/gae/store_appdata'

const security = useSecurityStore()
const appdata = useAppData()

onMounted(async () => {
  if (security.is_authenticated) {
    await security.fetchMe()
    appdata.fetch()
  }
})

// Chatbase : limité aux consultants
watch(() => security.user, (user) => {
  if (user && !security.isAdmin && !security.isAdminReadonly) {
    // @ts-ignore
    ;(function(){if(!window.chatbase||window.chatbase("getState")!=="initialized"){window.chatbase=(...args)=>{if(!window.chatbase.q){window.chatbase.q=[]}window.chatbase.q.push(args)};window.chatbase=new Proxy(window.chatbase,{get(target,prop){if(prop==="q"){return target.q}return(...args)=>target(prop,...args)}})}const script=document.createElement("script");script.src="https://www.chatbase.co/embed.min.js";script.id="MqH0wUI99UBDchmLRze8E";script.setAttribute("domain","www.chatbase.co");document.body.appendChild(script)})()
  } else if (!user) {
    // Clean widget when user disconnect
    // @ts-ignore
    if (window.chatbase) delete window.chatbase
    
    document.querySelectorAll('script[src*="chatbase"]').forEach(el => el.remove())
    document.querySelectorAll('[id*="chatbase"], [class*="chatbase"]').forEach(el => el.remove())
  }
})
</script>

<template>
  <RouterView />
</template>
